<!--
Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.

NVIDIA CORPORATION and its licensors retain all intellectual property
and proprietary rights in and to this software, related documentation
and any modifications thereto.  Any use, reproduction, disclosure or
distribution of this software and related documentation without an express
license agreement from NVIDIA CORPORATION is strictly prohibited.
-->
<div class="font-body2 learn-article-infotile-container">
    @for (topic of topics; track topic) {
        <mat-card class="learn-article-infotile" appearance="outlined">
            <mat-card-content class="card-content">
                <img class="learn-article-infotile-image" src="{{ getTopicImagePath(topic) }}" />
                <div class="learn-article-infotile-heading font-header6">
                    {{ topic.title }}
                </div>
                <div class="learn-article-infotile-content">
                    {{ topic.description }}
                </div>
                <mat-divider class="learn-article-infotile-divider"></mat-divider>
                <div class="learn-article-infotile-footer">
                    <button mat-flat-button class="font-button2 learn-article-infotile-footer">
                        <a href="{{ getTopicPath(topic) }}" target="_blank">Learn more</a>
                    </button>
                </div>
            </mat-card-content>
        </mat-card>
    }
</div>
